.messageBox {
  bottom: 56px;
}

.chat {
  background-color: #fff;
  overflow-y: scroll;
}
